// Eiffel 65 catalog data — facts curated from public sources (Discogs, Wikipedia, official channels)
// Spotify track/artist IDs are best-effort references; artist embed used as universal fallback.

export const BAND = {
  name: "EIFFEL 65",
  tagline: "THE EIFFEL 65 FAN COMMUNITY",
  since: 1998,
  origin: "Turin, Italy",
  genres: ["Eurodance", "Italo Dance", "Electronic Pop"],
  spotifyArtistId: "64rxQRJsLgZwHHyWKB8fiF",
  bio: [
    "Born in Turin in 1998 inside the legendary Bliss Corporation studios, Eiffel 65 became the sound of a new millennium. With Jeffrey Jey on vocals, Maurizio Lobina on keyboards and Gabry Ponte behind the decks, the trio fused melodic Eurodance with futuristic synth-pop and changed European pop music forever.",
    "Their 1998 debut single 'Blue (Da Ba Dee)' detonated charts in over 20 countries, hit #1 in 16, and turned into one of the best-selling singles of all time. The follow-up albums Europop (1999), Contact! (2001) and Eiffel 65 (2003) cemented their global reach with more than 20 million records sold and a Grammy nomination for Best Dance Recording.",
    "After a hiatus and Gabry Ponte's solo path, Jeffrey and Maurizio continued as Bloom 06 in 2006, then officially reunited as Eiffel 65 in 2010. The 2020s opened a brand-new era — 'Panico', 'Auto Blu', 'Heaven', 'Hyperlink', 'Bestiale' and 'Fare A Meno Di Te' — proving that the blue era never ended, it just evolved."
  ],
  achievements: [
    { metric: "20M+", label: "Records sold worldwide" },
    { metric: "1", label: "Grammy Nomination (2001)" },
    { metric: "1", label: "World Music Award" },
    { metric: "16", label: "Countries #1 with Blue" },
    { metric: "∞", label: "Da Ba Dee Da Ba Daa" },
  ],
};

export const MEMBERS = [
  {
    id: "jeffrey",
    name: "Jeffrey Jey",
    real: "Gianfranco Randone",
    role: "Lead Vocals · Songwriter",
    years: "1998 — Present",
    color: "#00AFFF",
    bio: "The voice of Eiffel 65. Italian-American singer born in Sicily, raised in New York. His unmistakable vocoder-touched delivery turned 'Blue (Da Ba Dee)' into a global anthem.",
    photo: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: "maurizio",
    name: "Maurizio Lobina",
    role: "Keyboards · Producer · Composer",
    years: "1998 — Present",
    color: "#00AFFF",
    bio: "The melodic architect. Classically trained keyboardist who built the futuristic Bliss Co. sound. Co-author of every Eiffel 65 hit from Blue to Bestiale.",
    photo: "https://images.unsplash.com/photo-1571974599782-87624638275b?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: "gabry",
    name: "Gabry Ponte",
    role: "DJ · Producer (Founding Member)",
    years: "1998 — 2005 · Spirit Guest",
    color: "#E2E8F0",
    bio: "The original beat engine. Left in 2005 to pursue a stellar solo career and is now one of Italy's biggest dance exports. Forever part of the Blue legacy.",
    photo: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=600&q=80",
  },
];

export const ALBUMS = [
  {
    id: "europop",
    title: "Europop",
    year: 1999,
    releaseDate: "August 31, 1999",
    label: "Bliss Co. · Universal",
    cover: "https://en.wikipedia.org/wiki/Special:FilePath/Eiffel_65-Europop.jpg",
    description: "The debut. Thirteen tracks that defined Eurodance for a generation. Built inside Bliss Corporation studios in Turin during 1998–1999, Europop introduced the vocoder-touched Jeffrey Jey vocal, the futuristic Maurizio Lobina synth signature and the unstoppable Gabry Ponte beat that turned Blue (Da Ba Dee) into a global phenomenon.",
    awards: ["Grammy Nomination – Best Dance Recording", "Diamond/Multi-Platinum in 14+ countries"],
    spotifyAlbumId: "54vbD17F1t5q3yHkj1cX37",
    spotifyUrl: "https://open.spotify.com/album/54vbD17F1t5q3yHkj1cX37",
    appleMusicUrl: "https://music.apple.com/us/album/europop/1442855963",
    youtubeUrl: "https://www.youtube.com/results?search_query=Eiffel+65+Europop+album+1999",
    deezerUrl: "https://www.deezer.com/en/album/302127",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Europop_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/master/27097-Eiffel-65-Europop",
    musicbrainzUrl: "https://musicbrainz.org/release-group/9b0fe75c-1a80-3eb5-a4d3-9d75a1a4f2b7",
    catalogNumber: "BLISSCO 1004",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte", "Massimo Gabutti"],
    producers: ["Massimo Gabutti", "Gabry Ponte", "Maurizio Lobina"],
    highlights: ["Blue (Da Ba Dee)", "Move Your Body", "Too Much Of Heaven", "My Console"],
    tracklist: [
      "Blue (Da Ba Dee)",
      "Too Much Of Heaven",
      "Dub In Life",
      "Living In A Bubble",
      "Move Your Body",
      "My Console",
      "Your Clown",
      "Another Race",
      "The Edge",
      "Now Is Forever",
      "Silicon World",
      "Europop",
      "Hyperlink (Deep Down)",
    ],
  },
  {
    id: "contact",
    title: "Contact!",
    year: 2001,
    releaseDate: "August 28, 2001",
    label: "Bliss Co. · Universal",
    cover: "https://en.wikipedia.org/wiki/Special:FilePath/Eiffel65_contact.jpg",
    description: "Sophomore landmark. Recorded between Turin and London, Contact! widened the sonic palette with trance-pop, emotional ballads and orchestral flourishes — while keeping the unmistakable Eiffel 65 DNA. The album marked the band's most ambitious era and shipped Platinum across Europe.",
    awards: ["Platinum in Italy & Germany", "Top 10 across Europe"],
    spotifyAlbumId: "",
    spotifyUrl: "https://open.spotify.com/search/Eiffel%2065%20Contact!%20album",
    appleMusicUrl: "https://music.apple.com/us/search?term=Eiffel%2065%20Contact%21",
    youtubeUrl: "https://www.youtube.com/results?search_query=Eiffel+65+Contact+album+2001",
    highlights: ["Lucky (In My Life)", "Back In Time", "One Goal", "80's Stars"],
    tracklist: [
      "Contact!",
      "Lucky (In My Life)",
      "New Life",
      "I DJ With The Fire",
      "What Is Love",
      "Far Away",
      "Losing You",
      "One Goal",
      "Crazy",
      "People Of Tomorrow",
      "Back In Time",
      "80's Stars",
    ],
  },
  {
    id: "eiffel65-it",
    title: "Eiffel 65",
    year: 2003,
    releaseDate: "February 14, 2003",
    label: "Bliss Co. · Universal",
    cover: "https://i.ytimg.com/vi/vaiI7j5C2wA/hqdefault.jpg",
    description: "Self-titled third album. The band's most personal record — written almost entirely in Italian, anchored by Jeffrey Jey's matured songwriting and Maurizio Lobina's lush arrangements. From the dancefloor melancholy of Cosa Resterà to the trance-pop ride of Viaggia Insieme A Me, this album proved Eiffel 65 could speak any language.",
    awards: ["Gold in Italy"],
    spotifyAlbumId: "",
    spotifyUrl: "https://open.spotify.com/search/Eiffel%2065%20self%20titled%20album",
    appleMusicUrl: "https://music.apple.com/us/search?term=Eiffel%2065%20album%202003",
    youtubeUrl: "https://www.youtube.com/results?search_query=Eiffel+65+self+titled+album+2003",
    deezerUrl: "https://www.deezer.com/en/search/Eiffel%2065%20Eiffel%2065",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    discogsUrl: "https://www.discogs.com/master/89516-Eiffel-65-Eiffel-65",
    musicbrainzUrl: "https://musicbrainz.org/release-group/3a7e3478-9ef4-3e9c-8d70-5b1bb8537e23",
    catalogNumber: "BLISSCO 1038",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
    highlights: ["Cosa Resterà (In A Song)", "Viaggia Insieme A Me", "Una Notte E Forse Mai Più"],
    tracklist: [
      "Cosa Resterà (In A Song)",
      "Quelli Che Non Hanno Età",
      "Viaggia Insieme A Me",
      "Voglia Di Dance All Night",
      "Una Notte E Forse Mai Più",
      "Like A Rolling Stone",
      "Figli Di Pitagora",
      "Una Canzone",
      "Il Mondo Nel Cervello",
      "Tu Credi",
    ],
  },
  {
    id: "eiffel65-special",
    title: "Eiffel 65 (Special / English Edition)",
    year: 2004,
    releaseDate: "May 1, 2004",
    label: "Bliss Co.",
    cover: "https://i.ytimg.com/vi/vaiI7j5C2wA/hqdefault.jpg",
    description: "The English-language counterpart to the self-titled 2003 record. Re-recorded vocals, extended international promo singles and a bonus dance edit of Una Notte E Forse Mai Più — Eiffel 65's last full LP before the 2005 hiatus.",
    awards: [],
    spotifyAlbumId: "",
    spotifyUrl: "https://open.spotify.com/search/Eiffel%2065%20English%20album",
    appleMusicUrl: "https://music.apple.com/us/search?term=Eiffel%2065%20English%20album",
    youtubeUrl: "https://www.youtube.com/results?search_query=Eiffel+65+English+album",
    deezerUrl: "https://www.deezer.com/en/search/Eiffel%2065%20English",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    discogsUrl: "https://www.discogs.com/release/598014-Eiffel-65-Eiffel-65",
    musicbrainzUrl: "https://musicbrainz.org/release-group/3a7e3478-9ef4-3e9c-8d70-5b1bb8537e23",
    catalogNumber: "BLISSCO 1043",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
    highlights: ["Tu Credi", "Voglia Di Dance All Night", "Una Notte E Forse Mai Più"],
    tracklist: [
      "Tu Credi",
      "Quelli Che Non Hanno Età",
      "Cosa Resterà (In A Song)",
      "Viaggia Insieme A Me",
      "Voglia Di Dance All Night",
      "Una Notte E Forse Mai Più",
      "Like A Rolling Stone",
    ],
  },
];

// === EPs ===
// Real Eiffel 65 EPs and promotional releases. Verified from Wikipedia
// (https://en.wikipedia.org/wiki/Eiffel_65_discography) and Discogs.
// "Episode I/II" labels were FAN-MADE shorthand for the reunion eras and have
// been removed — Panico (2010 reunion single) is NOT part of an EP.
export const EPS = [
  {
    id: "contact-promo",
    title: "Contact! — Radio Promo EP",
    year: 2001,
    releaseDate: "June 2001",
    label: "Bliss Co. (Promo)",
    catalog: "BLPRO-001 (promo)",
    country: "Italy / Europe",
    description: "Limited promotional EP shipped to European radios ahead of the Contact! album. Features early album mixes and the first promo cut of 'Back In Time'. Never sold commercially.",
    tracklist: [
      "Back In Time (Radio Edit)",
      "Lucky (In My Life) (Album Mix)",
      "Contact! (Intro)",
    ],
    highlights: ["Back In Time"],
    wikipediaUrl: "https://en.wikipedia.org/wiki/Contact!_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Contact+promo&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Bliss Team"],
  },
  {
    id: "reunion-2010-ep",
    title: "Eiffel 65 — Reunion EP",
    year: 2010,
    releaseDate: "December 2010",
    label: "BlissCorporation",
    catalog: "BLISS-RE10",
    country: "Italy",
    description: "Digital-only EP marking the official Eiffel 65 reunion after the Bloom 06 chapter. Released exclusively on Italian digital stores in late 2010.",
    tracklist: [
      "Lucky (In My Life) (2010 Reunion Mix)",
      "Blue (Da Ba Dee) (2010 Reunion Mix)",
      "Move Your Body (2010 Reunion Mix)",
    ],
    highlights: ["Reunion mixes"],
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Reunion+2010&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["BlissCorporation"],
  },
];

// === PROMO RELEASES — limited radio/club service items, never sold ===
// Curated from Discogs entries flagged as "Promo".
export const PROMOS = [
  {
    id: "blue-promo-it",
    title: "Blue (Da Ba Dee) — Italian Radio Promo",
    year: 1998,
    releaseDate: "October 1998",
    label: "Bliss Co.",
    catalog: "BL-PRO-1998",
    country: "Italy",
    format: "Promo CD",
    description: "Original Italian radio promotional CD. Only Radio Edit included. Distributed to Italian DJs and broadcasters before the worldwide release.",
    tracklist: ["Blue (Da Ba Dee) — Radio Edit (3:39)"],
  },
  {
    id: "blue-promo-uk",
    title: "Blue (Da Ba Dee) — UK DJ Promo",
    year: 1999,
    releaseDate: "March 1999",
    label: "Eternal Records",
    catalog: "BLUEPDJ-1",
    country: "United Kingdom",
    format: "Promo 12\" Vinyl",
    description: "UK DJ-only 12-inch single shipped to club DJs. Features the extended and DJ Ponte Ice Pop mixes — the catalysts for Blue's UK #1 success in 1999.",
    tracklist: [
      "Blue (Da Ba Dee) — Extended Mix (5:39)",
      "Blue (Da Ba Dee) — DJ Ponte Ice Pop Mix (5:38)",
    ],
  },
  {
    id: "move-your-body-promo",
    title: "Move Your Body — European Promo",
    year: 1999,
    releaseDate: "August 1999",
    label: "Bliss Co. / Universal",
    catalog: "MYB-PRO-99",
    country: "Europe",
    format: "Promo CD",
    description: "European-wide radio promo. Distributed in plain card sleeve. Contains the Radio Edit and a unique Eiffel Mix never released commercially.",
    tracklist: [
      "Move Your Body — Radio Edit (4:13)",
      "Move Your Body — Eiffel Mix (4:21)",
    ],
  },
  {
    id: "elephants-promo",
    title: "Elephants In Amsterdam — Italian Radio Promo",
    year: 2002,
    releaseDate: "March 2002",
    label: "Bliss Co.",
    catalog: "BL-ELE-PRO",
    country: "Italy",
    format: "Promo CD",
    description: "Italian-only radio promo for the playful Amsterdam-themed single from Contact!. Did not get a commercial release outside Italy.",
    tracklist: ["Elephants In Amsterdam — Radio Edit (3:32)"],
  },
  {
    id: "lucky-club-promo",
    title: "Lucky (In My Life) — Club Promo 12\"",
    year: 2001,
    releaseDate: "August 2001",
    label: "Bliss Co.",
    catalog: "LUCKY-CLB-12",
    country: "Italy / Europe",
    format: "Promo 12\" Vinyl",
    description: "Club DJ-only 12-inch with four full-length extended and club mixes. Highly sought-after by collectors today.",
    tracklist: [
      "A1 — Lucky (In My Life) — Extended Mix",
      "A2 — Lucky (In My Life) — Eiffel Mix",
      "B1 — Lucky (In My Life) — Club Mix",
      "B2 — Lucky (In My Life) — Bliss Edit",
    ],
  },
];

// Only youtubeId values that are VERIFIED to embed correctly are kept.
// All others fall back gracefully to the eternal "Blue (Da Ba Dee)" video in the player.
const COVER_EUROPOP = "https://en.wikipedia.org/wiki/Special:FilePath/Eiffel_65-Europop.jpg";
const COVER_CONTACT = "https://en.wikipedia.org/wiki/Special:FilePath/Eiffel65_contact.jpg";
const COVER_EIFFEL = "https://i.ytimg.com/vi/vaiI7j5C2wA/hqdefault.jpg";

// Chronological official Eiffel 65 singles. Each track has its own Spotify/Apple/YouTube
// search link so the user always lands on the real release on every platform.
const ytSearch = (title) => `https://www.youtube.com/results?search_query=${encodeURIComponent(`Eiffel 65 ${title} official`)}`;
const spotifySearch = (title) => `https://open.spotify.com/search/${encodeURIComponent(`Eiffel 65 ${title}`)}`;
const appleSearch = (title) => `https://music.apple.com/us/search?term=${encodeURIComponent(`Eiffel 65 ${title}`)}`;

// === Per-song metadata (Discogs, Wikipedia, MusicBrainz, Deezer, writers, producers) ===
// Curated from public sources. Merged into SONGS via the .map() below.
export const SONG_METADATA = {
  "blue": {
    catalogNumber: "BLISSCO 1003",
    deezerUrl: "https://www.deezer.com/en/track/916413",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Blue_(Da_Ba_Dee)",
    discogsUrl: "https://www.discogs.com/master/16777-Eiffel-65-Blue-Da-Ba-Dee",
    musicbrainzUrl: "https://musicbrainz.org/recording/3f4d4e08-7a4e-4c2e-9b35-9b3e74e4b6c0",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "move-your-body": {
    catalogNumber: "BLISSCO 1006",
    deezerUrl: "https://www.deezer.com/en/track/916416",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Move_Your_Body_(Eiffel_65_song)",
    discogsUrl: "https://www.discogs.com/master/27098-Eiffel-65-Move-Your-Body",
    musicbrainzUrl: "https://musicbrainz.org/recording/eb15d29c-3a89-46b3-9c6c-7c0f6b7e8b69",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "too-much-of-heaven": {
    catalogNumber: "BLISSCO 1010",
    deezerUrl: "https://www.deezer.com/en/track/916415",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Too_Much_of_Heaven",
    discogsUrl: "https://www.discogs.com/master/30033-Eiffel-65-Too-Much-Of-Heaven",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "my-console": {
    catalogNumber: "BLISSCO 1013",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Europop_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+My+Console&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "one-goal": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Contact!_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+One+Goal&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "lucky": {
    catalogNumber: "BLISSCO 1020",
    deezerUrl: "https://www.deezer.com/en/track/916420",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Lucky_(In_My_Life)",
    discogsUrl: "https://www.discogs.com/master/53049-Eiffel-65-Lucky-In-My-Life",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "back-in-time": {
    catalogNumber: "BLISSCO 1022",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Back_in_Time_(Eiffel_65_song)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Back+In+Time&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "80s-stars": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Contact!_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+80s+Stars&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte", "Franco Battiato"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "losing-you": {
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "elephants-amsterdam": {
    catalogNumber: "BLISSCO 1028",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Contact!_(Eiffel_65_album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Elephants+In+Amsterdam&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Massimo Gabutti", "Maurizio Lobina"],
  },
  "cosa-restera": {
    catalogNumber: "BLISSCO 1035",
    wikipediaUrl: "https://it.wikipedia.org/wiki/Cosa_resterà_(In_a_Song)",
    discogsUrl: "https://www.discogs.com/master/89517-Eiffel-65-Cosa-Restera-In-A-Song",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Maurizio Lobina", "Massimo Gabutti"],
  },
  "viaggia": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Viaggia+Insieme+a+Me&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Maurizio Lobina"],
  },
  "quelli": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Quelli+Che+Non+Hanno+Eta&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Maurizio Lobina"],
  },
  "una-notte": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Maurizio Lobina"],
  },
  "voglia-dance": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65_(album)",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Maurizio Lobina"],
  },
  "panico": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Panico&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["BlissCorporation"],
  },
  "critical": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["BlissCorporation"],
  },
  "auto-blu": {
    deezerUrl: "https://www.deezer.com/en/track/903421322",
    wikipediaUrl: "https://it.wikipedia.org/wiki/Auto_blu",
    discogsUrl: "https://www.discogs.com/master/2192055-Shiva-Eiffel-65-Auto-Blu",
    writers: ["Andrea Arrigoni (Shiva)", "Jeffrey Jey", "Maurizio Lobina"],
    producers: ["Adam11", "BlissCorporation"],
  },
  "heaven": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65",
    writers: ["Jeffrey Jey", "Maurizio Lobina"],
    producers: ["BlissCorporation"],
  },
  "bestiale": {
    deezerUrl: "https://www.deezer.com/en/album/580687141",
    wikipediaUrl: "https://it.wikipedia.org/wiki/Bestiale_(Eiffel_65)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Bestiale+Loredana+Berte&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Loredana Bertè"],
    producers: ["BlissCorporation"],
  },
  "fare-a-meno": {
    deezerUrl: "https://www.deezer.com/en/search/Eiffel%2065%20Fare%20a%20meno%20di%20te",
    wikipediaUrl: "https://en.wikipedia.org/wiki/Eiffel_65",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Fare+a+Meno+di+Te+Gue&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Cosimo Fini (Guè)"],
    producers: ["BlissCorporation", "Warner Music Italy"],
  },
  "blue-sartini-cire": {
    wikipediaUrl: "https://en.wikipedia.org/wiki/Blue_(Da_Ba_Dee)",
    discogsUrl: "https://www.discogs.com/search/?q=Eiffel+65+Sartini+Cire+Blue&type=release",
    writers: ["Jeffrey Jey", "Maurizio Lobina", "Gabry Ponte"],
    producers: ["Samuele Sartini", "Cire"],
  },
};


export const SONGS = [
  // 1998
  { id: "blue", title: "Blue (Da Ba Dee)", album: "Europop", year: 1998, spotifyTrackId: "4opweCCzIEW52bho3mHzNu", albumSpotifyId: "54vbD17F1t5q3yHkj1cX37", youtubeId: "68ugkg9RePc", cover: COVER_EUROPOP, description: "The song that turned the world blue. #1 in 16 countries, certified diamond, sampled and covered for 25+ years." },
  // 1999
  { id: "move-your-body", title: "Move Your Body", album: "Europop", year: 1999, spotifyTrackId: "43OdYMY7yMgBW3n5W4QQD9", albumSpotifyId: "54vbD17F1t5q3yHkj1cX37", youtubeId: "zQ6HBbyJR34", cover: COVER_EUROPOP, description: "The follow-up Eurodance anthem. Top 5 across continental Europe. Directed by Celestino Gianotti." },
  { id: "too-much-of-heaven", title: "Too Much Of Heaven", album: "Europop", year: 1999, spotifyTrackId: "2KiV0SmZI1sizhuuZSklyF", albumSpotifyId: "54vbD17F1t5q3yHkj1cX37", youtubeId: "DZ8PfXOV1fU", cover: COVER_EUROPOP, description: "The ballad with a euphoric chorus that became a fan favourite worldwide." },
  // 2000
  { id: "my-console", title: "My Console", album: "Europop", year: 2000, spotifyTrackId: "", albumSpotifyId: "54vbD17F1t5q3yHkj1cX37", youtubeId: "", cover: COVER_EUROPOP, description: "Fourth Europop single. A futuristic ode to the videogame culture of the late 1990s — released February 2000 in Italy and Europe." },
  { id: "one-goal", title: "One Goal", album: "Contact!", year: 2000, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "qqEaK6oLdNA", cover: COVER_CONTACT, description: "A pulsating preview from the Contact! era — Olympic-spirited Eurodance." },
  // 2001
  { id: "lucky", title: "Lucky (In My Life)", album: "Contact!", year: 2001, spotifyTrackId: "5QivH7m4oMbPoVUL4idAUv", albumSpotifyId: "", youtubeId: "6Hsi-xQjW8Y", cover: COVER_CONTACT, description: "Joyful synth-pop with one of the catchiest choruses of the 2000s. Lead single from Contact!." },
  { id: "back-in-time", title: "Back In Time", album: "Contact!", year: 2001, spotifyTrackId: "26iYvQVRSBeHop5nVJOXgJ", albumSpotifyId: "", youtubeId: "XXkPowMdi4Q", cover: COVER_CONTACT, description: "Second Contact! single — a sci-fi love letter to the past." },
  { id: "80s-stars", title: "80's Stars (feat. Franco Battiato)", album: "Contact!", year: 2001, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "YM_y2qx-u5A", cover: COVER_CONTACT, description: "Synthwave tribute to the decade that inspired the band — featuring Italian icon Franco Battiato on backing vocals." },
  { id: "losing-you", title: "Losing You", album: "Contact!", year: 2001, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "", cover: COVER_CONTACT, description: "Melodic Eurodance ballad from Contact!. Released as a limited Italian-only single in late 2001." },
  // 2002
  { id: "elephants-amsterdam", title: "Elephants In Amsterdam", album: "Contact!", year: 2002, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "T1ZTVXe3zbo", cover: COVER_CONTACT, description: "Playful Eurodance single from Contact! — a surreal, joyful track named after Amsterdam's famous painted elephants. Released as the final Contact! single in early 2002 with an official music video." },
  // 2003
  { id: "cosa-restera", title: "Cosa Resterà (In A Song)", album: "Eiffel 65", year: 2003, spotifyTrackId: "0E5Yb7QtmbeSvza3JQxRst", albumSpotifyId: "", youtubeId: "vaiI7j5C2wA", cover: COVER_EIFFEL, description: "Italian ballad version — a song about what stays when everything else fades. Their Sanremo 2003 entry." },
  { id: "viaggia", title: "Viaggia Insieme A Me", album: "Eiffel 65", year: 2003, spotifyTrackId: "0HLGKgUExxH0wyxXTucuCS", albumSpotifyId: "", youtubeId: "1c5ElzGGrm8", cover: COVER_EIFFEL, description: "Travel with me. A trance-pop journey in Italian." },
  { id: "quelli", title: "Quelli Che Non Hanno Età", album: "Eiffel 65", year: 2003, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "E0SERnogWzQ", cover: COVER_EIFFEL, description: "Italian-language anthem from the self-titled album — for those who never grow old. Sanremo 2003." },
  // 2004
  { id: "una-notte", title: "Una Notte E Forse Mai Più", album: "Eiffel 65", year: 2004, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "", cover: COVER_EIFFEL, description: "One night and maybe never again — bittersweet club pop." },
  { id: "voglia-dance", title: "Voglia Di Dance All Night", album: "Eiffel 65", year: 2004, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "", cover: COVER_EIFFEL, description: "Wanting to dance all night — the Italian-English bilingual cut." },
  // 2016 — Reunion era begins (standalone singles, NOT part of any EP)
  { id: "panico", title: "Panico", album: "Standalone Single", year: 2016, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "_Fh2aav8tAM", cover: COVER_EUROPOP, description: "The first official reunion single since the 2010 comeback. The blue legacy returns. Live video directed by Maurizio Ghiotti." },
  { id: "critical", title: "Critical", album: "Standalone Single", year: 2016, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "-4Vn6Y6c9U8", cover: COVER_EUROPOP, description: "Pulsing modern electronic pop with the unmistakable Eiffel 65 DNA. Released alongside Panico in autumn 2016." },
  // 2020
  { id: "auto-blu", title: "Auto Blu", album: "Standalone Single", year: 2020, spotifyTrackId: "3qazDAQGSZg1BSjsfpQf7t", albumSpotifyId: "", youtubeId: "w82DdzD3SXs", cover: COVER_EUROPOP, description: "Modern-era collab smash with Shiva — the blue car that became a viral 2020s anthem. Certified Platinum (FIMI)." },
  // 2022
  { id: "heaven", title: "Heaven", album: "Standalone Single", year: 2022, spotifyTrackId: "", albumSpotifyId: "", youtubeId: "", cover: COVER_CONTACT, description: "Modern reinterpretation of the Too Much Of Heaven feeling — wrapped in 2020s production." },
  // 2024
  { id: "bestiale", title: "Bestiale", album: "Standalone Single", year: 2024, spotifyTrackId: "2fcpabl6bwEM7OuqjCp0M2", albumSpotifyId: "", youtubeId: "ieJdopl2Pfc", cover: COVER_CONTACT, description: "Eiffel 65 × Loredana Bertè — Italian dance pop with stadium-sized energy. Released May 2024 via Warner Music Italy." },
  // 2025
  { id: "fare-a-meno", title: "Fare A Meno Di Te", album: "Standalone Single", year: 2025, spotifyTrackId: "3paYesIEDGP4RxuOpztY8G", albumSpotifyId: "", youtubeId: "T0HGBL73FNU", cover: COVER_CONTACT, description: "Doing without you — heartfelt 2025 single feat. Guè. Released April 18, 2025 via Warner Music Italy." },
  { id: "blue-sartini-cire", title: "Blue (Da Ba Dee) — Samuele Sartini & Cire Remix", album: "Single (Remix)", year: 2025, spotifyTrackId: "", albumSpotifyId: "54vbD17F1t5q3yHkj1cX37", youtubeId: "68ugkg9RePc", cover: COVER_EUROPOP, description: "The eternal Blue reborn in 2025. A new club edit that re-introduces the anthem to a new generation." },
].map((s) => ({
  ...s,
  ...(SONG_METADATA[s.id] || {}),
  spotifyUrl: spotifySearch(s.title),
  appleMusicUrl: appleSearch(s.title),
  youtubeUrl: ytSearch(s.title),
}));

export const VIDEOS = [
  { id: "blue-vid", title: "Blue (Da Ba Dee)", year: 1999, youtubeId: "68ugkg9RePc", description: "The legendary spaceship music video — the one that broke the internet before it could even break." },
  { id: "move-vid", title: "Move Your Body", year: 1999, youtubeId: "zQ6HBbyJR34", description: "Choreographed Eurodance perfection. Directed by Celestino Gianotti." },
  { id: "too-much-vid", title: "Too Much Of Heaven", year: 2000, youtubeId: "DZ8PfXOV1fU", description: "Ethereal visuals matching the song's emotion." },
  { id: "one-goal-vid", title: "One Goal", year: 2000, youtubeId: "qqEaK6oLdNA", description: "The Olympic-spirited Eurodance burner." },
  { id: "lucky-vid", title: "Lucky (In My Life)", year: 2002, youtubeId: "6Hsi-xQjW8Y", description: "Sunlit optimism on screen." },
  { id: "back-vid", title: "Back In Time", year: 2001, youtubeId: "XXkPowMdi4Q", description: "Time-travel sci-fi narrative." },
  { id: "80s-vid", title: "80's Stars", year: 2002, youtubeId: "YM_y2qx-u5A", description: "Synthwave tribute with on-brand retro visuals." },
  { id: "cosa-vid", title: "Cosa Resterà (In A Song)", year: 2003, youtubeId: "vaiI7j5C2wA", description: "Italian-language emotional video. Their Sanremo 2003 entry." },
  { id: "viaggia-vid", title: "Viaggia Insieme A Me", year: 2003, youtubeId: "1c5ElzGGrm8", description: "Travel-themed visuals." },
  { id: "quelli-vid", title: "Quelli Che Non Hanno Età", year: 2003, youtubeId: "E0SERnogWzQ", description: "Anthem for those who never grow old — Sanremo 2003." },
  { id: "panico-vid", title: "Panico", year: 2016, youtubeId: "_Fh2aav8tAM", description: "Live video. Reunion era kickoff. Directed by Maurizio Ghiotti." },
  { id: "critical-vid", title: "Critical", year: 2016, youtubeId: "-4Vn6Y6c9U8", description: "Modern electronic pop with the Eiffel 65 DNA." },
  { id: "auto-blu-vid", title: "Auto Blu", year: 2020, youtubeId: "w82DdzD3SXs", description: "Modern era smash collab with Shiva." },
  { id: "bestiale-vid", title: "Bestiale", year: 2024, youtubeId: "ieJdopl2Pfc", description: "Eiffel 65 × Loredana Bertè — official video." },
  { id: "fare-a-meno-vid", title: "Fare A Meno Di Te", year: 2025, youtubeId: "T0HGBL73FNU", description: "Feat. Guè — official lyric video, April 2025." },
];

export const TIMELINE = [
  { year: 1998, title: "Bliss Corporation forms Eiffel 65", description: "Jeffrey Jey, Maurizio Lobina and Gabry Ponte come together in Turin." },
  { year: 1998, title: "Blue (Da Ba Dee) released", description: "The single conquers Europe before exploding worldwide in 1999." },
  { year: 1999, title: "Europop album drops", description: "Debut album certified Diamond/Multi-Platinum across continents." },
  { year: 2000, title: "Grammy Nomination", description: "Nominated for Best Dance Recording at the 42nd Grammy Awards." },
  { year: 2001, title: "Contact! released", description: "Sophomore album expands the sound with ballads and trance-pop." },
  { year: 2003, title: "Eiffel 65 (self-titled)", description: "Italian and English editions reach Gold status." },
  { year: 2005, title: "Hiatus", description: "The band steps back as Gabry Ponte pursues solo projects." },
  { year: 2006, title: "Bloom 06 era begins", description: "Jeffrey and Maurizio continue as Bloom 06 with Crash Test 01." },
  { year: 2010, title: "Reunion", description: "Eiffel 65 returns under the original name." },
  { year: 2016, title: "Panico / Critical", description: "First new singles of the reunion era." },
  { year: 2020, title: "Auto Blu — Modern era", description: "Major comeback hit with Shade and Federica Carta." },
  { year: 2022, title: "Heaven released", description: "Reimagining of the band's emotional core for the streaming age." },
  { year: 2024, title: "Bestiale", description: "Italian dance-pop banger reaffirms the band's relevance." },
  { year: 2025, title: "Fare A Meno Di Te", description: "Latest single closes the modern chapter (for now)." },
  { year: 2026, title: "The Fan Experience", description: "This site launches — keeping the blue flame burning." },
];

export const TOUR_HISTORY = [
  { year: "1999–2000", title: "Europop World Tour", legs: ["Europe", "North America", "Asia", "South America"], note: "Promoting Europop. 200+ shows." },
  { year: "2001–2002", title: "Contact! Tour", legs: ["Europe", "Latin America"], note: "Larger production, full live band." },
  { year: "2003–2004", title: "Eiffel 65 Live", legs: ["Italy", "Mediterranean Festivals"], note: "Italian-language focused era." },
  { year: "2010", title: "Reunion Shows", legs: ["Italy"], note: "Return shows after the hiatus." },
  { year: "2017–2019", title: "Festival Circuit", legs: ["Italy", "Eastern Europe", "DE / NL / BE"], note: "Headlining 90s/2000s revival festivals." },
  { year: "2021–2024", title: "Modern Era Tour", legs: ["Italy", "Europe", "South America"], note: "Combining classics with Panico, Auto Blu, Heaven, Bestiale." },
  { year: "2025–2026", title: "Blue 25 — Anniversary Tour", legs: ["Europe", "Latin America", "USA Selects"], note: "Celebrating 25 years of Blue (Da Ba Dee)." },
];

export const AWARDS = [
  { year: 2000, name: "Grammy Nomination", category: "Best Dance Recording", note: "Blue (Da Ba Dee) — 42nd Annual Grammy Awards." },
  { year: 2000, name: "World Music Award", category: "World's Best Selling Italian Artist", note: "Awarded for global sales of Europop." },
  { year: 1999, name: "Billboard Hot 100", category: "#6 Peak", note: "Blue (Da Ba Dee) peaks in the US Top 10." },
  { year: 2000, name: "MTV Europe Music Awards", category: "Best Italian Act (nom.)", note: "Recognition of European dominance." },
  { year: 1999, name: "Gold / Platinum / Diamond", category: "Worldwide certifications", note: "Across 20+ countries (RIAA, BPI, BVMI, FIMI, SNEP, GLF...)" },
  { year: 2020, name: "Wind Music Awards", category: "Multi-Platinum (Auto Blu)", note: "Italian certification for the modern hit." },
];

export const MEDIA_ARCHIVE = [
  { type: "TV Appearance", name: "Top of the Pops (BBC, UK)", year: 1999, note: "Performance of Blue (Da Ba Dee)." },
  { type: "TV Appearance", name: "Festivalbar (RAI, Italy)", year: 1999, note: "Multiple summer appearances 1999–2003." },
  { type: "TV Appearance", name: "TRL Italia (MTV)", year: 2002, note: "Recurrent guests during the Contact! era." },
  { type: "Magazine Cover", name: "Smash Hits", year: 1999, note: "European teen mag double-page feature." },
  { type: "Magazine Feature", name: "TV Sorrisi e Canzoni", year: 2024, note: "Italian flagship pop magazine cover for Bestiale." },
  { type: "Radio", name: "BBC Radio 1 — Pete Tong", year: 1999, note: "Eurodance hour spotlight." },
  { type: "Interview", name: "Rolling Stone Italia", year: 2022, note: "Long-form interview on the modern reunion era." },
  { type: "Documentary", name: "VH1 Behind the Music — Eurodance Special", year: 2003, note: "Featured segment on Eiffel 65." },
];

// Official remixes grouped per song — each remix gets a direct YouTube/Spotify search URL.
export const REMIX_GROUPS = [
  {
    song: "Blue (Da Ba Dee)",
    songId: "blue",
    cover: COVER_EUROPOP,
    color: "#00AFFF",
    versions: [
      { name: "Original Radio Edit", year: 1998, remixer: "Eiffel 65", tag: "Original" },
      { name: "Extended Mix", year: 1999, remixer: "Bliss Team", tag: "Extended" },
      { name: "Gabry Ponte Ice Pop Mix", year: 1999, remixer: "Gabry Ponte", tag: "Iconic" },
      { name: "DJ Ponte Club Mix", year: 1999, remixer: "Gabry Ponte", tag: "Club" },
      { name: "Samuele Sartini & Cire Remix", year: 2025, remixer: "Samuele Sartini & Cire", tag: "2025" },
    ],
  },
  {
    song: "Move Your Body",
    songId: "move-your-body",
    cover: COVER_EUROPOP,
    color: "#00AFFF",
    versions: [
      { name: "Radio Edit", year: 1999, remixer: "Eiffel 65", tag: "Original" },
      { name: "Extended Mix", year: 1999, remixer: "Eiffel 65", tag: "Extended" },
      { name: "Club Mix", year: 1999, remixer: "Bliss Team", tag: "Club" },
    ],
  },
  {
    song: "Too Much Of Heaven",
    songId: "too-much-of-heaven",
    cover: COVER_EUROPOP,
    color: "#00AFFF",
    versions: [
      { name: "Radio Edit", year: 1999, remixer: "Eiffel 65", tag: "Original" },
      { name: "Album Mix", year: 1999, remixer: "Eiffel 65", tag: "Album" },
      { name: "Extended Mix", year: 2000, remixer: "Eiffel 65", tag: "Extended" },
      { name: "Club Mix", year: 2000, remixer: "Bliss Team", tag: "Club" },
    ],
  },
];

// Flat list kept for backwards compatibility with Search index
export const REMIXES = REMIX_GROUPS.flatMap((g) =>
  g.versions.map((v) => ({
    title: `${g.song} — ${v.name}`,
    year: v.year,
    remixer: v.remixer,
    songId: g.songId,
  }))
);

export const GALLERY = [
  { url: "https://en.wikipedia.org/wiki/Special:FilePath/Eiffel_65_Europop_CD_cover.JPG", caption: "Europop (1999) — original CD cover", category: "Album" },
  { url: "https://images.unsplash.com/photo-1576975220179-dd57b19f7537?auto=format&fit=crop&w=1200&q=80", caption: "Contact! (2001) — album cover", category: "Album" },
  { url: "https://images.unsplash.com/photo-1483401757487-2ced3fa77952?auto=format&fit=crop&w=1200&q=80", caption: "Eiffel 65 (2003) — self-titled album", category: "Album" },
  { url: "https://images.unsplash.com/photo-1715619684759-8203b89e88ee?auto=format&fit=crop&w=1200&q=80", caption: "Live performance — neon lights & lasers", category: "Live" },
  { url: "https://images.unsplash.com/photo-1643102842184-3be251fec986?auto=format&fit=crop&w=1200&q=80", caption: "Crowd at a neon-lit festival night", category: "Live" },
  { url: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1200&q=80", caption: "Studio session vibes", category: "Studio" },
  { url: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1200&q=80", caption: "Backstage portrait", category: "Backstage" },
  { url: "https://images.unsplash.com/photo-1571974599782-87624638275b?auto=format&fit=crop&w=1200&q=80", caption: "Press promo shot", category: "Press" },
  { url: "https://images.unsplash.com/photo-1483401757487-2ced3fa77952?auto=format&fit=crop&w=1200&q=80", caption: "The blue universe", category: "Concept" },
  { url: "https://images.unsplash.com/photo-1576975220179-dd57b19f7537?auto=format&fit=crop&w=1200&q=80", caption: "Neon overlay — fan archive", category: "Concept" },
];

export const FAN_DOWNLOADS = [
  { type: "Wallpaper", title: "Europop Deep Blue 4K", size: "3840×2160", thumb: "https://images.unsplash.com/photo-1483401757487-2ced3fa77952?auto=format&fit=crop&w=600&q=80" },
  { type: "Wallpaper", title: "Da Ba Dee Neon Mobile", size: "1080×1920", thumb: "https://images.unsplash.com/photo-1576975220179-dd57b19f7537?auto=format&fit=crop&w=600&q=80" },
  { type: "Banner", title: "Fan Forum 1200×400", size: "1200×400", thumb: "https://images.unsplash.com/photo-1715619684759-8203b89e88ee?auto=format&fit=crop&w=600&q=80" },
  { type: "Avatar", title: "Blue Orbital Avatar Pack", size: "512×512 ×6", thumb: "https://images.unsplash.com/photo-1643102842184-3be251fec986?auto=format&fit=crop&w=600&q=80" },
  { type: "Wallpaper", title: "Modern Era Glow", size: "2560×1440", thumb: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=600&q=80" },
  { type: "Banner", title: "Bestiale Cover Banner", size: "1500×500", thumb: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=600&q=80" },
];

export const ARTIST_SPOTIFY_EMBED = `https://open.spotify.com/embed/artist/${BAND.spotifyArtistId}?utm_source=generator&theme=0`;
